import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { TreeItem, TreeView } from '@material-ui/lab';
import { groupBy } from 'utilities/arrays';
import { ArrowDropDown, ArrowRight } from '@material-ui/icons';
import { Typography } from '@material-ui/core';

const GroupShapeDetail = ({ classes, selectedCustomShape }) => {
  // == useState ============================================

  const [geoLevelMap, setGeoLevelMap] = useState(null);
  const [treeExpanded, setTreeExpanded] = useState([]);

  // == useEffect ===========================================

  useEffect(() => {
    if (selectedCustomShape) {
      const geoLevelMap = groupBy(
        selectedCustomShape.details,
        (detail) => detail.geoLevel
      );
      setGeoLevelMap(geoLevelMap);
      setTreeExpanded(Array.from(geoLevelMap.keys()));
    }
  }, [selectedCustomShape]);

  // == Helpers =============================================

  const getNumDetails = (details) => {
    return details.filter((detail) => detail.found).length;
  };

  // == Event Handlers ======================================

  const handleToggle = (event, nodeIds) => {
    setTreeExpanded(nodeIds);
  };

  // == Components ==========================================

  const renderTree = (geoLevelGroup) => (
    <TreeItem
      key={geoLevelGroup[0]}
      nodeId={geoLevelGroup[0]}
      label={
        <div className={classes.labelRoot}>
          <Typography variant='subtitle2' className={classes.labelText}>
            {geoLevelGroup[0]} ({getNumDetails(geoLevelGroup[1])})
          </Typography>
        </div>
      }
    >
      {geoLevelGroup[1].map(
        (detail) =>
          detail.found && (
            <TreeItem
              key={detail.geoId}
              nodeId={detail.geoId}
              label={
                <div className={classes.labelRoot}>
                  <Typography
                    variant='body2'
                    className={
                      detail.found ? classes.labelText : classes.notFoundText
                    }
                  >
                    {detail.geoId}
                  </Typography>
                </div>
              }
            ></TreeItem>
          )
      )}
    </TreeItem>
  );

  return (
    <TreeView
      defaultCollapseIcon={<ArrowDropDown />}
      defaultExpandIcon={<ArrowRight />}
      onNodeToggle={handleToggle}
      expanded={treeExpanded}
    >
      {geoLevelMap && geoLevelMap.size > 0 ? (
        Array.from(geoLevelMap).map((geoLevelGroup) =>
          renderTree(geoLevelGroup)
        )
      ) : (
        <></>
      )}
    </TreeView>
  );
};

// == Styles =============================================

const styles = (theme) => ({
  container: {
    margin: '8px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
    backgroundColor: '#cbcbcb',
    borderBottom: '1px solid #b7b7b7',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    minWidth: 0,
  },
  headerRight: {
    display: 'flex',
  },
  noShapesDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 42,
    margin: '4px 8px',
  },
  noShapesText: {
    fontStyle: 'italic',
    color: '#a7a9ac',
    fontSize: '.9rem',
  },
  menuButton: {
    padding: 2,
  },
  headerText: {
    fontSize: '1.2rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  // Treeview label
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelText: {
    flexGrow: 1,
  },
  missingLabel: {
    color: 'red',
    marginLeft: '2px',
  },
  notFoundText: {
    flexGrow: 1,
    color: 'red',
  },
});

// == Connect =============================================

const mapStateToProps = ({ assumptionGroupsState }) => ({
  selectedCustomShape: assumptionGroupsState.selectedCustomShape,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(GroupShapeDetail);
